import getStore from '../store/store';
import { DropViewState, DraggableItemTypes } from 'owa-dnd';
import { getDraggedItemType } from 'owa-module-dnd-store';
import { OwaDate } from 'owa-datetime';

// TIME PANEL DATA STATE SELECTORS
export function isTimePanelDataInitialized(): boolean {
    return getStore().isTimePanelDataInitialized;
}

// TIME PANEL SELECTORS

export function getTimePanelDropState(): DropViewState {
    return getStore().timePanelDropViewState;
}

export function getEventDropState(): DropViewState {
    return getStore().eventDropViewState;
}

export function getTaskDropState(): DropViewState {
    return getStore().taskDropViewState;
}

// TIME PANEL TAB SELECTORS

export function getCalendarTabDropState(): DropViewState {
    return getStore().calendarTabDropViewState;
}

export function getTasksTabDropState(): DropViewState {
    return getStore().tasksTabDropViewState;
}

export function shouldShowCalendarTabHoverHint(): boolean {
    return (
        getCalendarTabDropState().draggableItemType === DraggableItemTypes.MailListRow ||
        getDraggedItemType() === DraggableItemTypes.MailListRow ||
        getTimePanelDropState().draggableItemType === DraggableItemTypes.MailListRow
    );
}

export function shouldShowTasksTabHoverHint(): boolean {
    return (
        getTasksTabDropState().draggableItemType === DraggableItemTypes.MailListRow ||
        getDraggedItemType() === DraggableItemTypes.MailListRow ||
        getTimePanelDropState().draggableItemType === DraggableItemTypes.MailListRow
    );
}

export function getLastDragOverCalendarTab(): OwaDate | null {
    return getStore().lastDragOverCalendarTab;
}

export function getLastDragOverTasksTab(): OwaDate | null {
    return getStore().lastDragOverTasksTab;
}

// DAY VIEW SELECTORS

export function isHoveringOverDayDropHint(): boolean {
    return getStore().shouldShowHoverDayDrop;
}

export function enableDayViewDropPreview(): boolean {
    return getTimePanelDropState().draggableItemType === DraggableItemTypes.MailListRow;
}

export function getDayViewDropTimeMinuteOffset(): number | null {
    return getStore().dayViewDropTimeMinuteOffset;
}

// UPNEXT SELECTORS

export function getLastDragOverUpNext(): OwaDate | null {
    return getStore().lastDragOverUpNext;
}

export function getUpNextDropState(): DropViewState {
    return getStore().upNextDropViewState;
}

export function shouldShowUpNextHoverHint(): boolean {
    return (
        getStore().upNextDropViewState &&
        (getStore().upNextDropViewState.draggableItemType === DraggableItemTypes.MailListRow ||
            getDraggedItemType() === DraggableItemTypes.MailListRow)
    );
}
